var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreAccDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account details"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 14V13C16 12.4696 15.7752 11.9609 15.3752 11.5858C14.9751 11.2107 14.4325 11 13.8667 11H10.1333C9.56754 11 9.02492 11.2107 8.62484 11.5858C8.22476 11.9609 8 12.4696 8 13V14",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11Z",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41274",
    x: 3,
    y: 2,
    width: 18,
    height: 20,
    rx: 4,
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251059",
    d: "M9 17H14.7622",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreAccDetails);
export default __webpack_public_path__ + "static/media/more-acc-details.9536b67bb1cd671a7edd968d50808fc3.svg";
export { ForwardRef as ReactComponent };